import React from "react"
import Faq from "../base-pages/faq"

const FaqEN = () => {
  return <Faq lang="en" />
}

export default FaqEN
